module.exports = __webpack_public_path__ + "static/frontier-logo-c0ffd0b37f5f6ef2928ccf00f18362e4.svg";